import { DatePipe } from '@angular/common';
import {
	Component,
	EventEmitter,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { MainArea } from '../../../core/enums/main-area.enum';
import { HttpBodyReqPaginationModel } from '../../../core/models';
import { Parameter } from '../../../core/models/util/api-adapter-service-models';
import { AppResponse } from '../../../core/models/util/api-dto/response-models/app-response';
import { ApiAdapterServiceService } from '../../../core/services/api-adapter-service.service';
import { CampaignTotalDto } from '../../models/campaign-count-final-response-dto.model';
import {
	CampaignListTableColumnConst,
	CampaignListTableLabelConst,
	TableModel,
} from './models';
import { CampaignResponseDtoApi } from './models/campaign-response-dto.model';

@Component({
	selector: 'lib-campaign-index',
	templateUrl: './campaign-index.component.html',
	styleUrls: ['./campaign-index.component.scss'],
})
export class CampaignIndexComponent implements OnInit, OnDestroy {
	@Output() currentView = new EventEmitter<MainArea>();

	public table: TableModel;
	public filterValue: any;
	public currentViews = MainArea;
	public campaignTotal: CampaignTotalDto;

	private campaignParam: HttpBodyReqPaginationModel;
	private subscribers: Subscription[] = [];

	constructor(
		private datePipe: DatePipe,
		private apiAdapterService: ApiAdapterServiceService
	) {}

	ngOnInit(): void {
		this.campaignParam = new HttpBodyReqPaginationModel();

		this.initTable();
		this.campaignCountService();
		this.getCampaignList();

		localStorage.removeItem('telin.campaign');
	}

	private initTable(): void {
		this.table = new TableModel();
		this.table.labels = CampaignListTableLabelConst;
		this.table.columns = CampaignListTableColumnConst;
	}

	private campaignCountService() {
		const subs = this.apiAdapterService
			.executeApiRequest([], '/campaign/totals', 'GET')
			.subscribe((response: AppResponse<CampaignTotalDto>) => {
				this.campaignTotal = response?.data;
			});

		this.subscribers.push(subs);
	}

	public getCampaignList(searchValue: string = ''): void {
		const parameterList: Array<Parameter> = [
			this.initParam('pageNo', this.campaignParam.pageNo, 'number'),
			this.initParam('rowPerPage', this.campaignParam.pageSize, 'number'),
			this.initParam('filter', searchValue, 'string'),
		];

		if (this.filterValue?.businessName)
			parameterList.push(
				this.initParam(
					'clientId',
					this.filterValue.businessName,
					'string'
				)
			);
		if (this.filterValue?.medium)
			parameterList.push(
				this.initParam('channel', this.filterValue.medium, 'string')
			);
		if (this.filterValue?.templateName)
			parameterList.push(
				this.initParam(
					'templateName',
					this.filterValue.templateName?.name,
					'string'
				)
			);
		if (this.filterValue?.status)
			parameterList.push(
				this.initParam('status', this.filterValue.status, 'string')
			);
		if (this.filterValue?.startDate)
			parameterList.push(
				this.initParam(
					'startDate',
					this.datePipe.transform(
						this.filterValue.startDate,
						'yyyy-MM-dd'
					),
					'string'
				)
			);
		if (this.filterValue?.endDate)
			parameterList.push(
				this.initParam(
					'endDate',
					this.datePipe.transform(
						this.filterValue.endDate,
						'yyyy-MM-dd'
					),
					'string'
				)
			);

		const subs = this.apiAdapterService
			.executeApiRequest(parameterList, '/campaign', 'GET')
			.subscribe((resp: AppResponse<CampaignResponseDtoApi[]>) => {
				this.table.dataSource.data = resp.data;
				this.table.setNextPage(resp.haveNext);
			});

		this.subscribers.push(subs);
	}

	private initParam(_name: string, _value: any, _type: string): Parameter {
		return {
			name: _name,
			value: _value,
			in: 'query',
			type: _type,
		};
	}

	public updatePage(event: any): void {
		if (event.pageSize) {
			this.table.totalData = event.pageSize;
			this.table.setPageSize(event.pageSize);
			this.table.resetPage();
		} else {
			this.table.setPage(event);
		}

		this.campaignParam.pageNo = this.table.page;
		this.campaignParam.pageSize = this.table.pageSize;
		this.getCampaignList();
	}

	public updateFilter(_filter: any) {
		this.table.resetPage();
		this.campaignParam.pageNo = this.table.page;
		this.campaignParam.pageSize = this.table.pageSize;
		this.filterValue = _filter;

		this.getCampaignList();
	}

	public updateSearch(searchValue: string) {
		this.table.resetPage();
		this.campaignParam.pageNo = this.table.page;
		this.getCampaignList(searchValue);
	}

	public addCampaign(): void {
		localStorage.removeItem('telin.campaign');
		this.changeCurrentView(this.currentViews.NewCampaign);
	}

	public changeCurrentView(area: MainArea) {
		this.currentView.emit(area);
	}

	ngOnDestroy(): void {
		this.subscribers.forEach(each => each.unsubscribe());
	}
}
